import React from "react";
import { FormField } from '@prosolve/common-components-ui'

export default ({
  formData,
  isEdit
}) => {

  const ticketTypeOptions = [
    { value: 'Both', text: 'Round Trip' },
    { value: 'Departing', text: 'Departing'  },
    { value: 'Returning', text: 'Returning' },
  ]

  return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <div style={{
          display: 'flex',
          columnGap: '15px'
        }}>
          <FormField
            style={{ flex: 1 }}
            fieldId='personFlying'
            type='text'
            label='Name(s)'
            placeholder='e.g. John Smith'
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='flightType'
            type='select'
            width='100%'
            label='Ticket Type'
            formData={formData}
            options={ticketTypeOptions}
            disabled={isEdit}
          />
        </div>
        <div style={{
          display: 'flex',
          columnGap: '15px'
        }}>
          <FormField
            style={{ flex: 1 }}
            fieldId='airline'
            type='text'
            label='Airline'
            placeholder='e.g. Delta'
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='flightConfirmation'
            type='text'
            label='Confirmation Number'
            placeholder='e.g. H5A9W2'
            formData={formData}
          />
        </div>
      </div>
  )
}